import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MsgConfig } from "src/app/app.messages";
import { ModalWrapperService } from "src/app/services";
@Component({
  selector: "app-common-warnorconfirm-popup",
  templateUrl: "./common-warnorconfirm-popup.component.html",
  standalone: false
})
export class CommonWarnorconfirmPopupComponent implements OnInit {
    @ViewChild("WarnPopup", { static: true }) WarnPopup: any;
    @ViewChild("PAErrorMessage", {static: true}) PAErrorMessage: any;
    @ViewChild("CommonErrorMessage", {static: true}) CommonErrorMessage: any;
    @Input() warnMsg: any;
    @Input() okButton: boolean;
    @Input() yesButton: boolean;
    @Input() noButton: boolean;
    @Input() isPopSize: string;
    @Input() IsHeaderText: string;
    @Input() recallButton: boolean;
    @Input() closeButton: boolean;
    @Input() okayFinalButton: boolean;
    @Input() Defer:boolean;
    @Input() IgnoreAndContinue:boolean;
    @Input() CancelButton:boolean;
    @Input() buttonType:boolean;
    @Input() shortcutKey:any;
    @Input() hideCross: boolean;
    @Input() isfromPA : boolean;
    @Input() RxNum: any;
    @Input() isCommonError : boolean;
    @Input() handleCrossClick: boolean;
    @Input() eyconDPVDocsExist: boolean;
    @Input() displayPaidTransMsg: boolean;
    @Input() includePath: boolean;
    removeEyeconImages = true;
    @Output() removeEyeconImagesChange = new EventEmitter<boolean>();
    @Output()
    IsPopUpClosed = new EventEmitter<boolean>();
    msgConfig = MsgConfig;
     @HostListener("window:keydown", ["$event"])
        keyEventAlt(event: KeyboardEvent) {
            if (event.which === 27) {
                this.closeEvent(false);
                event.preventDefault();
            }
        }

    modelRef: any;
    modelRefWarn: any;
  constructor(private _modalService: ModalWrapperService,private _cd: ChangeDetectorRef) { }

  ngOnInit() {
    // Sentry.captureException([
    //   {name: this.warnMsg}
    // ]);
    if(this.isfromPA) {
        this.modelRef = this._modalService.open(this.PAErrorMessage, {centered: true, backdrop: false, keyboard: false, windowClass: this.isPopSize ? this.isPopSize+' confirmation-warn-popup-container' : "large--content confirmation-warn-popup-container"});
        this.handleModalClose(this.modelRef);
    } else if(this.isCommonError) {
        this.modelRef = this._modalService.open(this.CommonErrorMessage, {centered: true, backdrop: false, keyboard: false, windowClass: this.isPopSize ? this.isPopSize+' confirmation-warn-popup-container' : "large--content_medium_sm confirmation-warn-popup-container"});
        this.handleModalClose(this.modelRef);
    } else {
      if(this.warnMsg.includes("Session has timed out. Please login to continue.")){
        this.modelRefWarn = this._modalService.open(this.WarnPopup, {centered: true,
          backdrop: false, keyboard: false, windowClass: this.isPopSize ? this.isPopSize+' confirmation-warn-popup-container session-timeout-popup' : "large--content confirmation-warn-popup-container session-timeout-popup"});
      } else if(this.warnMsg.includes("Are you sure you want to delete?")){
        this.modelRefWarn = this._modalService.open(this.WarnPopup, {centered: true,
          backdrop: false, keyboard: false, windowClass: this.isPopSize ? this.isPopSize+'delete-confirmation-popup' : "large--content delete-confirmation-popup"});
      } else{
        this.modelRefWarn = this._modalService.open(this.WarnPopup, {centered: true,
          backdrop: false, keyboard: false, windowClass: this.isPopSize ? this.isPopSize+' confirmation-warn-popup-container' : "large--content confirmation-warn-popup-container"});
      }
      this.handleModalClose(this.modelRefWarn);
      setTimeout(() => {
        if (document.getElementById((this.Defer === false) ? "CancelButton" : "focuschange")) {
            document.getElementById((this.Defer === false) ? "CancelButton" : "focuschange").focus();
        }
      }, 0);
    }
  }
  handleModalClose(modelRef){
     if ((modelRef as any)?.onClose) {
        (modelRef as any).onClose.then((res) => {
          if(res === 'esc') {
            this.closeEvent(false);
          }
        });
      }
  }

  closeEvent(type, onCrossClick?) {
    this.closePop();
    this.removeEyeconImagesChange.emit(this.removeEyeconImages);
    this.IsPopUpClosed.emit((onCrossClick && this.handleCrossClick) ? false : type);
  }
  patchQtyDisp(clickedType) {
    this.closePop();
    this.removeEyeconImagesChange.emit(this.removeEyeconImages);
    this.IsPopUpClosed.emit(clickedType);
  }
  closePop() {
    if(this.modelRef) {
      this.modelRef.close();
      this.modelRef = null;
    }
    if(this.modelRefWarn) {
      this.modelRefWarn.close();
      this.modelRefWarn = null;
    }
   }
}



